<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <!--<div class="logo_form"><img :src="getTranslations.logo_for_branded_projects || 'static/images/Swipo_logo_02.png'" alt=""></div>-->
            <div class="form_title">
              <h1>{{ getTranslations.visitor_forgot_password_1_recover_your_password }}</h1>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasStepsToDisplay">
              <div class="StandardRegSteps_step">1</div>
              <div class="StandardRegSteps_step inactive">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <img class="form-help__icon" src="static/images/mobile-icon.svg" alt="">
              <h1>{{ getTranslations.visitor_forgot_password_1_forgot_your_pin }} </h1>
              <p>{{ getTranslations.visitor_forgot_password_1_please_enter }} </p>
            </div>
            <form action="">
              <div :class="[ ' form-group form-group--mobile form-group--icon', !hasErrors ? '' : 'has-warning' ]">
                <input type="number"
                       :placeholder="getTranslations.visitor_forgot_password_1_enter_mobile_number"
                       class="mobile form-group__textfield phone_input"
                       @keyup="check"
                       v-model="user.msisdn">
                <span class="form-group__feedback"
                      v-show="getMessage(message) && user.msisdn">
                  {{ getMessage(message) }}
                </span>
              </div>
              <button type="submit"
                      :class="['btn btn--medium btn--main', ( hasErrors ? 'deactivated' : ''), (hasValidMsisdn ? '' : 'deactivated')]"
                      @click.prevent="checkButton">
                {{ getTranslations.visitor_forgot_password_1_submit_button_continue }}
              </button>
              <!--ADD CLASS "deactivated" IF "has-warning" IS ACTIVE AS WELL ABOVE-->
              <!--span class="form-group__code">$#You need a new unique code? <a href="#">$#Resend me a code</a></span-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';

export default {
  name: 'forgotPassword1',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      user: {
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      hasStepsToDisplay: false,
      hasValidMsisdn: false,
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSimplify();
  },
  methods: {
    ...mapMutations('profile', [
      'setForgotPasswordInfo',
    ]),
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    clearData() {
      this.user.msisdn = '';
      this.message = '';
      this.hasErrors = false;
    },
    check() {
      const validMsisdnRegex = /^[0-9]||[()+-]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
        this.hasValidMsisdn = true;
      }
    },
    checkButton() {
      if (!this.hasErrors) {
        this.message = '';
        this.$axios.get(`api/requestNewPin?msisdn=${this.user.msisdn}&lang=${this.getLocale}`).then((response) => {
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.setForgotPasswordInfo(response.data.data);
            this.getNextForgotPasswordStep()();
            this.user.msisdn = '';
            this.message = '';
          } else {
            if (res === 'MSISDN_INVALID') {
              this.message = 'visitor_forgot_password_invalid_msisdn_msg';
            } else if (res === 'ALREADY_REGISTERED') {
              this.message = 'visitor_forgot_password_msisdn_already_registered';
            } else if (res === 'MSISDN_NOT_EXIST') {
              this.message = 'visitor_forgot_password_msisdn_not_exists';
            } else if (res === 'MSISDN_BLACKLISTED') {
              this.message = 'visitor_forgot_password_msisdn_blacklisted';
            } else if (res === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if (res === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'CAMPAIGN_CLOSED') {
              this.message = 'visitor_sign_up_campaign_closed';
            } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword1.vue